const BENI_LOCAL_STORAGE_KEYS = {
  SELECTED_KPI_HERO_CHART: 'beniSelectedKpiHeroChart',
  SELECTED_KPI_LOS_CHART: 'beniSelectedKpiLosChart',
  SELECTED_KPI_CHANNEL: 'beniSelectedKpiChannel',
  SELECTED_AXIS_OPTION: 'beniSelectedAxisOption',
  SELECTED_LOS_SORT_OPTION: 'beniSelectedLosSortOption',
  SELECTED_LOS_CHART_OCCUPANCY_VIEW: 'beniSelectedLosChartOccupancyView',
  SELECTED_CHANNEL_OCCUPANCY_VIEW: 'beniSelectedChannelOccupancyView',
  REFERENCE_PERIOD: 'beniReferencePeriod',
  PICKUP: 'beniPickup',
  PRIMARY_DATA_SET: 'beniPrimaryDataSet',
  SECONDARY_DATA_SET: 'beniSecondaryDataSet',
  SELECTED_STAY_DATE_SECTION_VIEW: 'beniSelectedStayDateSectionView',
  BANNER_TRIAL_DISMISSED: 'beniBannerTrialDismissed',
  EXPANDED_BREAKDOWNS: 'beniExpandedBreakdowns',
};

export default BENI_LOCAL_STORAGE_KEYS;
